<ion-content
  data-cy="scheduled-maintenance-page"
  class="scheduled-maintenance-page_content"
  [class.tablet]="platformService?.platformType === platformService?.platformEnum?.tablet"
  [class.mobile]="platformService?.platformType === platformService?.platformEnum?.mobile"
>
  <div>
    <img
      data-cy="scheduled-maintenance-page-usf-logo-image"
      src="assets/images/usfoods-logo-color.svg"
    />
    <h1 data-cy="scheduled-maintenance-page-main-text" class="bold-font-weight">
      {{ 'i18n.maintenance.downForScheduledMaintenance' | translate }}
    </h1>
    <p data-cy="scheduled-maintenance-page-subtext" class="bold-font-weight">
      {{ 'i18n.maintenance.willBeBackASAP' | translate }}
    </p>
    <span
      data-cy="scheduled-maintenance-page-return-to-login-button"
      class="medium-font-weight"
      (click)="returnToLogin()"
    >
      {{ 'i18n.maintenance.returnToLogin' | translate }}
    </span>
  </div>
</ion-content>
